import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const meanDescription: CalculatorDescription = {
  title: 'Mean Calculator',
  metaTitle: 'Online Mean Calculator - Arithmetic, Geometric, and Harmonic Means',
  description: 'Calculate different types of means including arithmetic, geometric, and harmonic means. Understand which average is best for your data.',
  metaDescription: 'Calculate means online. Find arithmetic, geometric, and harmonic means with our free calculator. Statistical analysis made easy.',
  id: CalculatorId.MEAN,
  howTo: {
    title: 'How to Calculate Means',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically display the arithmetic, geometric, and harmonic means',
      'Review the visual representation and interpretations for each type of mean'
    ]
  },
  examples: [
    {
      title: 'Growth Rate Analysis',
      description: 'Analyze different types of means for growth rate data.',
      dataDescription: 'Growth rates (%) for a company over 10 periods: 2.5, 3.1, 2.8, 3.4, 2.9, 3.0, 2.7, 3.2, 2.6, 3.3',
      insights: [
        'Geometric mean is ideal for growth rates and ratios',
        'Arithmetic mean gives equal weight to all values',
        'Harmonic mean is best for rates and speeds',
        'Compare means to understand data characteristics'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.VARIANCE,
    CalculatorId.INTERQUARTILE_RANGE
  ]
}; 